import React from 'react';
import { Row, Col, Tabs, Tab, Button, ButtonToolbar } from 'react-bootstrap';
import ItemsSerialNoContainer from '../containers/ItemsSerialNoContainer.jsx';
import WashLabelContainer from '../containers/WashLabelContainer.jsx';
import BagLabelContainer from '../containers/BagLabelContainer.jsx';
import LabelEditContainer from '../containers/LabelEditContainer.jsx';
import LabelRestoreContainer from '../containers/LabelRestoreContainer.jsx';
import SpecialNoteListContainer from '../containers/SpecialNoteListContainer.jsx';

import DropDownInput from './common/DropDownInput.jsx';

export default class LabelComponent extends React.Component {

  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    this.props.findAllOrderIds();
    if (this.props.orderId) {
      if (this.props.eventKey === 0) {
        this.props.findNoLabelGeneratedCount({ orderId: this.props.orderId });
        this.props.findSerialNoData({ orderId: this.props.orderId });
        this.props.clearSerialNoDownloadUrl();
      } else if (this.props.eventKey === 1) {
        this.props.clearSpecialNoteDownloadUrl();
        this.props.findSpecialNoteList({ orderId: this.props.orderId });
      } else if (this.props.eventKey === 2) {
      } else if (this.props.eventKey === 3) {
      } else if (this.props.eventKey === 4) {
      } else if (this.props.eventKey === 5) {
        this.props.findDeletedLogIds({ orderId: this.props.orderId });
      }
    }
  }

  handleSelect(key) {
    this.props.changeEventKey(key);
    if (key === 0) {
      this.props.findNoLabelGeneratedCount({ orderId: this.props.orderId });
      this.props.findSerialNoData({ orderId: this.props.orderId });
      this.props.clearSerialNoDownloadUrl();
    } else if (key === 1) {
      this.props.clearSpecialNoteDownloadUrl();
      this.props.findSpecialNoteList({ orderId: this.props.orderId });
    } else if (key === 2) {
    } else if (key === 3) {
    } else if (key === 4) {
    } else if (key === 5) {
      this.props.findDeletedLogIds({ orderId: this.props.orderId });
    }
  }

  handleExport() {
    this.props.exportSpecialNoteList({ orderId: this.props.orderId });
  }

  render() {

    let downloadLinkStyle = {
      display: this.props.specialNoteDownloadUrl === '' ? 'none' : 'block'
    };

    let openXls = () => {
      window.open(this.props.specialNoteDownloadUrl);
    };

    let roles = this.props.roles;
    let restoreTab = null;
    if (roles.includes("ROLE_FIREFIGHTER_ADMIN")) {
      restoreTab = (
        <Tab eventKey={5} title="還原洗標">
            <LabelRestoreContainer />
        </Tab>
      );
    }

    return (
      <div>
        <h4>標籤管理</h4>
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
          <Col xs={6} sm={3} md={3}>
            <DropDownInput id="orderId"
              label="訂單編號"
              options={this.props.allOrderIds.map((value, key) => ({ label: value, value: value })).toJS()}
              selected={[{ label: this.props.orderId, value: this.props.orderId }]}
              onChange={(id, value, label) => {
                this.props.changeOrderId({ orderId: value });
                if (this.props.eventKey === 0) {
                  this.props.findNoLabelGeneratedCount({ orderId: value });
                  this.props.findSerialNoData({ orderId: value });
                  this.props.clearSerialNoDownloadUrl();
                } else if (this.props.eventKey === 1) {
                  this.props.clearSpecialNoteDownloadUrl();
                  this.props.findSpecialNoteList({ orderId: value });
                } else if (this.props.eventKey === 2) {
                } else if (this.props.eventKey === 3) {
                } else if (this.props.eventKey === 4) {
                } else if (this.props.eventKey === 5) {
                  this.props.findDeletedLogIds({ orderId: value });
                }
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
        <Col xs={12}>
          <Tabs id="editTab" defaultActiveKey={this.props.eventKey} animation={false} onSelect={this.handleSelect}>
            <Tab eventKey={0} title="序號表">
                <ItemsSerialNoContainer />
            </Tab>
            <Tab eventKey={1} title="備註列表">
              <Row style={{ marginTop: 10, marginBottom: 10 }}>
                <Col xs={12}>
                  <ButtonToolbar>
                    <Button bsStyle="info" onClick={(event) => {
                      this.handleExport();
                    }}>匯出xls檔</Button>
                    <Button style={downloadLinkStyle} bsStyle="default" onClick={openXls}>開啟xls檔</Button>
                  </ButtonToolbar>
                </Col>
              </Row>
              <SpecialNoteListContainer orderId={this.props.orderId} />
            </Tab>
            <Tab eventKey={2} title="洗標輸出">
                <WashLabelContainer />
            </Tab>
            <Tab eventKey={4} title="洗標修改">
                <LabelEditContainer />
            </Tab>
            {restoreTab}
            <Tab eventKey={3} title="標籤輸出">
                <BagLabelContainer />
            </Tab>
          </Tabs>
        </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/LabelComponent.jsx